import '../styles/pages/NotFound.scss';
import { useNavigate } from 'react-router-dom';
import { BsArrowRightShort } from "react-icons/bs";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="not-found">
            <div className="not-found-content">
                <h1 className="error-code">404</h1>
                <h2 className="error-title">Page introuvable</h2>
                <p className="error-message">
                    Oups ! La page que vous recherchez semble s'être perdue.<br />
                    Elle n'existe pas ou a été déplacée.
                </p>
                <div className="not-found-actions">
                    <button className="btn-primary" onClick={() => navigate('/')}>
                        <BsArrowRightShort /> Retour à l'accueil
                    </button>
                    <button className="btn-secondary" onClick={() => navigate('/products')}>
                        Explorer nos produits
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
